<div class="priority-header row justify-content-between">
  <div>{{stage.StageName}}</div>
  <!--
  <div>{{stage.TaskCountTotal ? stage.TaskCountTotal : 0}}</div>
  -->
</div>
<div class="execution row align-items-center justify-content-end">
  <div class="col col-md-10">
    <div class="progress">
      <div [class.progress-inprogress]="stage.PercentComplete < 100"
           [class.progress-complete]="stage.PercentComplete === 100"
           class="progress-bar" role="progressbar"
           [style.width]="stage.PercentComplete+'%'" attr.aria-valuenow="{{stage.PercentComplete}}" aria-valuemin="0" aria-valuemax="100">
      </div>
    </div>
  </div>
  <div style="text-align: right" class="col col-md-2  mx-0 pl-0 label-text">{{stage.PercentComplete}}%</div>
</div>

<div class="row align-items-center justify-content-end" *ngFor="let stage of stage.Stages">
  <div class="col-md-auto label-text">{{stage.StageName}}</div>

  <div class="progress">
    <div [class.progress-inprogress]="stage.PercentComplete < 100"
         [class.progress-complete]="stage.PercentComplete === 100"
         class="progress-bar" role="progressbar"
         [style.width]="stage.PercentComplete+'%'" attr.aria-valuenow="{{stage.PercentComplete}}" aria-valuemin="0" aria-valuemax="100">
    </div>
  </div>

  <div class="col col-md-2 label-text">
    {{stage.PercentComplete}}%
  </div>
</div>
